import { render, staticRenderFns } from "./authManagement.vue?vue&type=template&id=a9bbf352&scoped=true&"
import script from "./authManagement.vue?vue&type=script&lang=js&"
export * from "./authManagement.vue?vue&type=script&lang=js&"
import style0 from "./authManagement.vue?vue&type=style&index=0&id=a9bbf352&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bbf352",
  null
  
)

export default component.exports